import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";
import { TextareaField } from "@ps-design-system/components/Textarea";
import LockIcon from "@ps-design-system/icons/Lock/Lock16";

import { useIntl } from "react-intl-compat";

const DirectionsField = () => {
  const intl = useIntl();

  return (
    <div className="tw-flex tw-flex-col tw-gap-16">
      <div className="tw-flex tw-flex-col tw-gap-8">
        <Text typeface="headline-4-b" element="h2" className="tw-m-0">
          <FormattedMessage
            id="hosting.arrival_guide.directions_header"
            defaultMessage="Provide arrival instructions"
          />
        </Text>
        <Text typeface="body-2" element="p" className="tw-m-0">
          <FormattedMessage
            id="hosting.arrival_guide.directions_subheader"
            defaultMessage="Help your guests and their attendees find and enter your space."
          />
        </Text>
      </div>

      <div>
        <Text typeface="body-2-m">
          <FormattedMessage
            id="hosting.arrival_guide.directions_try_to_include"
            defaultMessage="Try to include:"
          />
        </Text>
        <ul className="tw-list-disc tw-list-inside tw-m-0">
          <Text element="li">
            <FormattedMessage
              id="hosting.arrival_guide.directions_example"
              defaultMessage="Directions to your space, building access, door buzzers, floors, stairs/elevator access etc."
            />
          </Text>
        </ul>
      </div>

      <TextareaField
        fullWidth
        name="directions"
        placeholder={intl.formatMessage({
          id: "hosting.arrival_guide.directions_placeholder",
          defaultMessage:
            "Example: We are located at 3rd and Northwood Ave across from Target. When you arrive, hit the buzzer for “428” and ask for Sarah and come up to floor 4, Apt 28.",
        })}
        testId="arrival-guide-form-directions-input"
      />

      <Text
        typeface="body-2"
        element="p"
        className="tw-m-0 tw-text-gray-600"
        prefix={<LockIcon className="tw-flex-shrink-0" />}
      >
        <FormattedMessage
          id="hosting.arrival_guide.wifi_footer"
          defaultMessage="Don't worry, we'll only share this with guests after you have accepted their booking."
        />
      </Text>
    </div>
  );
};

export { DirectionsField };
